<form [formGroup]="formGroup">
  <div data-test="week-registration">
    <div class="flex--column">
      <mat-form-field class="flex__child--auto" *ngIf="showField('mortality')">
        <mat-label>{{ 'week-registration.mortality' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="1"
          inputmode="decimal"
          formControlName="mortality"
          (input)="onMortalityChange()"
          placeholder="{{ 'week-registration.mortality' | translate }}"
          data-test="week-registration__mortality"
        />
        <mat-error *ngIf="!!formGroup.controls.mortality.errors">{{
          getValidationErrorMessage(valueRegistrationTypes.Mortality)
        }}</mat-error>
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('eggsAmount')">
        <mat-label>{{ 'week-registration.eggsAmount' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="1"
          inputmode="decimal"
          formControlName="eggsAmount"
          placeholder="{{ 'week-registration.eggsAmount' | translate }}"
          data-test="week-registration__eggAmount"
        />
        <mat-error *ngIf="!!formGroup.controls.eggsAmount.errors">{{
          getValidationErrorMessage(valueRegistrationTypes.EggsAmount)
        }}</mat-error>
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('eggsAmountSecondKind')">
        <mat-label>{{ 'week-registration.eggsAmountSecondKind' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="1"
          inputmode="decimal"
          formControlName="eggsAmountSecondKind"
          placeholder="{{ 'week-registration.eggsAmountSecondKind' | translate }}"
          data-test="week-registration__eggAmountSecondKind"
        />
        <mat-error *ngIf="!!formGroup.controls.eggsAmountSecondKind.errors">{{
          getValidationErrorMessage(valueRegistrationTypes.EggsAmountSecondKind)
        }}</mat-error>
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('eggWeight')">
        <mat-label>{{ 'week-registration.eggWeight' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          inputmode="decimal"
          formControlName="eggWeight"
          placeholder="{{ 'week-registration.eggWeight' | translate }}"
          data-test="week-registration__eggWeight"
        />
        <span matTextSuffix class="form-field-suffix">g</span>
        <mat-error *ngIf="!!formGroup.controls.eggWeight.errors">{{
          getValidationErrorMessage(valueRegistrationTypes.EggWeight)
        }}</mat-error>
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('forage')">
        <mat-label>{{ 'week-registration.forage' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          inputmode="decimal"
          formControlName="forage"
          placeholder="{{ 'week-registration.forage' | translate }}"
          data-test="week-registration__forage"
        />
        <span matTextSuffix class="form-field-suffix">kg</span>
        <mat-error *ngIf="!!formGroup.controls.forage.errors">{{
          getValidationErrorMessage(valueRegistrationTypes.Forage)
        }}</mat-error>
      </mat-form-field>

      <mat-form-field class="flex__child--auto" *ngIf="showField('forage')">
        <mat-label>{{ 'week-registration.forageProduct' | translate }}</mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          formControlName="forageProduct"
          data-test="week-registration__forageProduct"
          (selectionChange)="onForageProductChange($event, false)"
        >
          <mat-option [value]="null"> - </mat-option>
          <mat-option *ngFor="let forageProduct of forageProducts" [value]="forageProduct">
            {{ forageProduct }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="spacing--margin-bottom" *ngIf="showField('forage')">
        <mat-slide-toggle
          [hideIcon]="true"
          color="primary"
          formControlName="isSecondForage"
          data-test="week-registration__secondForageToggle"
          (change)="onIsSecondForageChange($event)"
        >
          {{ 'week-registration.secondForageToggle' | translate }}
        </mat-slide-toggle>
      </div>

      <ng-container *ngIf="showSecondForage && showField('forage')">
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'week-registration.secondForage' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            inputmode="decimal"
            formControlName="secondForage"
            placeholder="{{ 'week-registration.forage' | translate }}"
            data-test="week-registration__secondForage"
          />
          <span matTextSuffix class="form-field-suffix">kg</span>
          <mat-error *ngIf="!!formGroup.controls.secondForage.errors">{{
            getValidationErrorMessage(valueRegistrationTypes.SecondForage)
          }}</mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'week-registration.secondForageProduct' | translate }}</mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            formControlName="secondForageProduct"
            data-test="week-registration__secondForageProduct"
            (selectionChange)="onForageProductChange($event, true)"
          >
            <mat-option [value]="null"> - </mat-option>
            <mat-option *ngFor="let forageProduct of forageProducts" [value]="forageProduct">
              {{ forageProduct }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <mat-form-field class="flex__child--auto" *ngIf="showField('water')">
        <mat-label>{{ 'week-registration.water' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          inputmode="decimal"
          formControlName="water"
          placeholder="{{ 'week-registration.water' | translate }}"
          data-test="week-registration__water"
        />
        <span matTextSuffix class="form-field-suffix">l</span>
        <mat-error *ngIf="!!formGroup.controls.water.errors">{{
          getValidationErrorMessage(valueRegistrationTypes.Water)
        }}</mat-error>
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('henWeight')">
        <mat-label>{{ 'week-registration.henWeight' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          inputmode="decimal"
          formControlName="henWeight"
          placeholder="{{ 'week-registration.henWeight' | translate }}"
          data-test="week-registration__henWeight"
        />
        <span matTextSuffix class="form-field-suffix">g</span>
        <mat-error *ngIf="!!formGroup.controls.henWeight.errors">{{
          getValidationErrorMessage(valueRegistrationTypes.HenWeight)
        }}</mat-error>
      </mat-form-field>
      <mat-slide-toggle
        [hideIcon]="true"
        *ngIf="showField('moult')"
        formControlName="isInMoult"
        color="primary"
        class="spacing--margin-bottom spacing--padding-vertical"
        data-test="week-registration___isInMoult"
        (change)="onIsInMoultChange($event)"
      >
        <b>{{ 'week-registration.isInMoult' | translate }}</b>
        <div>
          <mat-label>{{ 'week-registration.isInMoultMessage' | translate }}</mat-label>
        </div>
      </mat-slide-toggle>
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'week-registration.remarks' | translate }}</mat-label>
        <textarea
          matInput
          formControlName="remarks"
          rows="4"
          placeholder="{{ 'week-registration.remarks' | translate }}"
          data-test="week-registration__remarks"
        ></textarea>
      </mat-form-field>
    </div>
  </div>
</form>
